function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoordinateList from './CoordinateList';
import Coordinate from './Coordinate';
import MathUtil from '../math/MathUtil';
import System from '../../../../java/lang/System';
import Comparator from '../../../../java/util/Comparator';
import Envelope from './Envelope';
var CoordinateArrays = /*#__PURE__*/function () {
  function CoordinateArrays() {
    _classCallCheck(this, CoordinateArrays);
    CoordinateArrays.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateArrays, [{
    key: "getClass",
    value: function getClass() {
      return CoordinateArrays;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "isRing",
    value: function isRing(pts) {
      if (pts.length < 4) return false;
      if (!pts[0].equals2D(pts[pts.length - 1])) return false;
      return true;
    }
  }, {
    key: "ptNotInList",
    value: function ptNotInList(testPts, pts) {
      for (var i = 0; i < testPts.length; i++) {
        var testPt = testPts[i];
        if (CoordinateArrays.indexOf(testPt, pts) < 0) return testPt;
      }
      return null;
    }
  }, {
    key: "scroll",
    value: function scroll(coordinates, firstCoordinate) {
      var i = CoordinateArrays.indexOf(firstCoordinate, coordinates);
      if (i < 0) return null;
      var newCoordinates = new Array(coordinates.length).fill(null);
      System.arraycopy(coordinates, i, newCoordinates, 0, coordinates.length - i);
      System.arraycopy(coordinates, 0, newCoordinates, coordinates.length - i, i);
      System.arraycopy(newCoordinates, 0, coordinates, 0, coordinates.length);
    }
  }, {
    key: "equals",
    value: function equals() {
      if (arguments.length === 2) {
        var coord1 = arguments[0];
        var coord2 = arguments[1];
        if (coord1 === coord2) return true;
        if (coord1 === null || coord2 === null) return false;
        if (coord1.length !== coord2.length) return false;
        for (var i = 0; i < coord1.length; i++) {
          if (!coord1[i].equals(coord2[i])) return false;
        }
        return true;
      } else if (arguments.length === 3) {
        var _coord = arguments[0];
        var _coord2 = arguments[1];
        var coordinateComparator = arguments[2];
        if (_coord === _coord2) return true;
        if (_coord === null || _coord2 === null) return false;
        if (_coord.length !== _coord2.length) return false;
        for (var _i = 0; _i < _coord.length; _i++) {
          if (coordinateComparator.compare(_coord[_i], _coord2[_i]) !== 0) return false;
        }
        return true;
      }
    }
  }, {
    key: "intersection",
    value: function intersection(coordinates, env) {
      var coordList = new CoordinateList();
      for (var i = 0; i < coordinates.length; i++) {
        if (env.intersects(coordinates[i])) coordList.add(coordinates[i], true);
      }
      return coordList.toCoordinateArray();
    }
  }, {
    key: "hasRepeatedPoints",
    value: function hasRepeatedPoints(coord) {
      for (var i = 1; i < coord.length; i++) {
        if (coord[i - 1].equals(coord[i])) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "removeRepeatedPoints",
    value: function removeRepeatedPoints(coord) {
      if (!CoordinateArrays.hasRepeatedPoints(coord)) return coord;
      var coordList = new CoordinateList(coord, false);
      return coordList.toCoordinateArray();
    }
  }, {
    key: "reverse",
    value: function reverse(coord) {
      var last = coord.length - 1;
      var mid = Math.trunc(last / 2);
      for (var i = 0; i <= mid; i++) {
        var tmp = coord[i];
        coord[i] = coord[last - i];
        coord[last - i] = tmp;
      }
    }
  }, {
    key: "removeNull",
    value: function removeNull(coord) {
      var nonNull = 0;
      for (var i = 0; i < coord.length; i++) {
        if (coord[i] !== null) nonNull++;
      }
      var newCoord = new Array(nonNull).fill(null);
      if (nonNull === 0) return newCoord;
      var j = 0;
      for (var _i2 = 0; _i2 < coord.length; _i2++) {
        if (coord[_i2] !== null) newCoord[j++] = coord[_i2];
      }
      return newCoord;
    }
  }, {
    key: "copyDeep",
    value: function copyDeep() {
      if (arguments.length === 1) {
        var coordinates = arguments[0];
        var copy = new Array(coordinates.length).fill(null);
        for (var i = 0; i < coordinates.length; i++) {
          copy[i] = new Coordinate(coordinates[i]);
        }
        return copy;
      } else if (arguments.length === 5) {
        var src = arguments[0];
        var srcStart = arguments[1];
        var dest = arguments[2];
        var destStart = arguments[3];
        var length = arguments[4];
        for (var _i3 = 0; _i3 < length; _i3++) {
          dest[destStart + _i3] = new Coordinate(src[srcStart + _i3]);
        }
      }
    }
  }, {
    key: "isEqualReversed",
    value: function isEqualReversed(pts1, pts2) {
      for (var i = 0; i < pts1.length; i++) {
        var p1 = pts1[i];
        var p2 = pts2[pts1.length - i - 1];
        if (p1.compareTo(p2) !== 0) return false;
      }
      return true;
    }
  }, {
    key: "envelope",
    value: function envelope(coordinates) {
      var env = new Envelope();
      for (var i = 0; i < coordinates.length; i++) {
        env.expandToInclude(coordinates[i]);
      }
      return env;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray(coordList) {
      return coordList.toArray(CoordinateArrays.coordArrayType);
    }
  }, {
    key: "atLeastNCoordinatesOrNothing",
    value: function atLeastNCoordinatesOrNothing(n, c) {
      return c.length >= n ? c : [];
    }
  }, {
    key: "indexOf",
    value: function indexOf(coordinate, coordinates) {
      for (var i = 0; i < coordinates.length; i++) {
        if (coordinate.equals(coordinates[i])) {
          return i;
        }
      }
      return -1;
    }
  }, {
    key: "increasingDirection",
    value: function increasingDirection(pts) {
      for (var i = 0; i < Math.trunc(pts.length / 2); i++) {
        var j = pts.length - 1 - i;
        var comp = pts[i].compareTo(pts[j]);
        if (comp !== 0) return comp;
      }
      return 1;
    }
  }, {
    key: "compare",
    value: function compare(pts1, pts2) {
      var i = 0;
      while (i < pts1.length && i < pts2.length) {
        var _compare = pts1[i].compareTo(pts2[i]);
        if (_compare !== 0) return _compare;
        i++;
      }
      if (i < pts2.length) return -1;
      if (i < pts1.length) return 1;
      return 0;
    }
  }, {
    key: "minCoordinate",
    value: function minCoordinate(coordinates) {
      var minCoord = null;
      for (var i = 0; i < coordinates.length; i++) {
        if (minCoord === null || minCoord.compareTo(coordinates[i]) > 0) {
          minCoord = coordinates[i];
        }
      }
      return minCoord;
    }
  }, {
    key: "extract",
    value: function extract(pts, start, end) {
      start = MathUtil.clamp(start, 0, pts.length);
      end = MathUtil.clamp(end, -1, pts.length);
      var npts = end - start + 1;
      if (end < 0) npts = 0;
      if (start >= pts.length) npts = 0;
      if (end < start) npts = 0;
      var extractPts = new Array(npts).fill(null);
      if (npts === 0) return extractPts;
      var iPts = 0;
      for (var i = start; i <= end; i++) {
        extractPts[iPts++] = pts[i];
      }
      return extractPts;
    }
  }]);
}();
export { CoordinateArrays as default };
var ForwardComparator = /*#__PURE__*/function () {
  function ForwardComparator() {
    _classCallCheck(this, ForwardComparator);
    ForwardComparator.constructor_.apply(this, arguments);
  }
  return _createClass(ForwardComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var pts1 = o1;
      var pts2 = o2;
      return CoordinateArrays.compare(pts1, pts2);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return ForwardComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
}();
ForwardComparator.constructor_ = function () {};
var BidirectionalComparator = /*#__PURE__*/function () {
  function BidirectionalComparator() {
    _classCallCheck(this, BidirectionalComparator);
    BidirectionalComparator.constructor_.apply(this, arguments);
  }
  return _createClass(BidirectionalComparator, [{
    key: "compare",
    value: function compare(o1, o2) {
      var pts1 = o1;
      var pts2 = o2;
      if (pts1.length < pts2.length) return -1;
      if (pts1.length > pts2.length) return 1;
      if (pts1.length === 0) return 0;
      var forwardComp = CoordinateArrays.compare(pts1, pts2);
      var isEqualRev = CoordinateArrays.isEqualReversed(pts1, pts2);
      if (isEqualRev) return 0;
      return forwardComp;
    }
  }, {
    key: "OLDcompare",
    value: function OLDcompare(o1, o2) {
      var pts1 = o1;
      var pts2 = o2;
      if (pts1.length < pts2.length) return -1;
      if (pts1.length > pts2.length) return 1;
      if (pts1.length === 0) return 0;
      var dir1 = CoordinateArrays.increasingDirection(pts1);
      var dir2 = CoordinateArrays.increasingDirection(pts2);
      var i1 = dir1 > 0 ? 0 : pts1.length - 1;
      var i2 = dir2 > 0 ? 0 : pts1.length - 1;
      for (var i = 0; i < pts1.length; i++) {
        var comparePt = pts1[i1].compareTo(pts2[i2]);
        if (comparePt !== 0) return comparePt;
        i1 += dir1;
        i2 += dir2;
      }
      return 0;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return BidirectionalComparator;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Comparator];
    }
  }]);
}();
BidirectionalComparator.constructor_ = function () {};
CoordinateArrays.ForwardComparator = ForwardComparator;
CoordinateArrays.BidirectionalComparator = BidirectionalComparator;
CoordinateArrays.constructor_ = function () {};
CoordinateArrays.coordArrayType = new Array(0).fill(null);